import { useEffect, useRef, useState } from "react";
import Constants from "../../constants";
import useCompetitionLeaderboard from "../CompetitionScoreboard/hooks/useCompetitionLeaderboard";
import Table from "../CompetitionTable";
import { Container } from "./CompetitionLeaderboard.style";
import { Participant } from "../../Types/Participant";

function CompetitionLeaderboard({
  competitionId,
  handicapCategoryType: handicapType,
  isGross,
  competitionMaster,
  leaderboardFormat,
  isLeagueLeaderboard,
}: {
  competitionId?: string;
  handicapCategoryType: string | null;
  isGross: boolean | null;
  competitionMaster: any;
  leaderboardFormat: number;
  isLeagueLeaderboard: boolean;
}) {
  const currentPaginationNumber = useRef(0);
  const listSize = useRef(0);
  const entriesPerTable = Constants.entriesPerTable;
  const total = entriesPerTable * 3;
  const tables = Constants.tables;
  const showItems = Math.floor(total / tables);
  const { participants, isLoading, error } = useCompetitionLeaderboard(
    competitionId ?? "",
    isGross,
    handicapType,
    leaderboardFormat,
    isLeagueLeaderboard
  );

  const [sortedParticipants, setSortedParticipants] = useState<Participant[]>(
    []
  );

  const rankList = (data: Participant[]): Participant[] => {
    // Sort by score count (higher is better), then by GrossScoreTotal (lower is better)
    data.sort((a, b) => {
      const countA = a?.thru ?? 0;
      const countB = b?.thru ?? 0;

      if (countA !== countB) {
        return countB - countA; // More scores should come first
      }

      return (
        (a.points?.GrossScoreTotal ?? 0) - (b.points?.GrossScoreTotal ?? 0)
      );
    });

    let rank = 1;
    let lastScore: number | null = null;
    let lastScoreCount: number | null = null;
    let tiedCount = 0;

    // First loop: Assign initial ranks
    data.forEach((item, index) => {
      const currentScore = item.points?.GrossScoreTotal ?? 0;
      const currentScoreCount = item?.thru ?? 0;

      if (currentScore === lastScore && currentScoreCount === lastScoreCount) {
        item.position = `T${rank}`; // Assign tie rank
        tiedCount++;
      } else {
        rank += tiedCount; // Adjust rank for next unique entry
        item.position = `${rank}`;
        tiedCount = 1; // Reset tie count
      }

      lastScore = currentScore;
      lastScoreCount = currentScoreCount;
    });

    // Second loop: Ensure all tied positions have the same rank
    for (let i = 0; i < data.length; i++) {
      if (i > 0 && data[i].position === `T${data[i - 1].position}`) {
        data[i].position = data[i - 1].position; // Make all tied positions the same
      }
    }

    return data;
  };

  useEffect(() => {
    console.log("Participants updated", participants, leaderboardFormat);
    if (leaderboardFormat === 0) {
      console.log(
        "sorted list",
        participants,
        rankList(participants),
        leaderboardFormat
      );
      setSortedParticipants(rankList(participants));
    } else {
      setSortedParticipants(participants);
    }
  }, [participants]);

  return (
    <Container>
      {sortedParticipants?.slice(0, showItems * 1)?.length > 0 && (
        <Table
          isLoading={isLoading}
          isGross={isGross}
          competitionMaster={competitionMaster}
          Participants={sortedParticipants?.slice(0, showItems * 1)}
        />
      )}
      {sortedParticipants?.slice(showItems * 1, showItems * 2)?.length > 0 && (
        <Table
          isLoading={isLoading}
          isGross={isGross}
          competitionMaster={competitionMaster}
          Participants={sortedParticipants?.slice(showItems * 1, showItems * 2)}
        />
      )}
      {sortedParticipants?.slice(showItems * 2)?.length > 0 && (
        <Table
          isLoading={isLoading}
          isGross={isGross}
          competitionMaster={competitionMaster}
          Participants={sortedParticipants?.slice(showItems * 2)}
        />
      )}
    </Container>
  );
}

export default CompetitionLeaderboard;
